import React from 'react';
import {
  BarChart, Bar, LineChart, Line, PieChart, Pie, AreaChart, Area,
  XAxis, YAxis, CartesianGrid, Tooltip as RechartsTooltip, Legend, ResponsiveContainer, Cell,
} from 'recharts';
import type { ArtifactViewerProps } from '../types';
import type { ChartContent } from './shared';

export const CHART_COLORS = ['#2563eb', '#06b6d4', '#10b981', '#f59e0b', '#ef4444', '#8b5cf6', '#ec4899', '#14b8a6'];

export const ChartViewer: React.FC<ArtifactViewerProps> = ({ artifact }) => {
  const c = artifact.content as Partial<ChartContent>;
  const data = Array.isArray(c?.data) ? c.data : [];
  const xKey = typeof c?.xKey === 'string' ? c.xKey : 'name';
  const yKey = typeof c?.yKey === 'string' ? c.yKey : 'value';
  const type = c?.type ?? 'bar';

  if (data.length === 0) {
    return <div className="p-4 text-sm text-muted-foreground">Nessun dato disponibile</div>;
  }
  return (
    <div className="bg-card p-4 rounded-lg">
      {c?.title && <div className="text-sm font-semibold mb-3 text-foreground">{c.title}</div>}
      <ResponsiveContainer width="100%" height={280}>
        {type === 'pie' ? (
          <PieChart>
            <Pie data={data} dataKey={yKey} nameKey={xKey} outerRadius={100} label>
              {data.map((_, i) => <Cell key={i} fill={CHART_COLORS[i % CHART_COLORS.length]} />)}
            </Pie>
            <RechartsTooltip />
            <Legend />
          </PieChart>
        ) : type === 'line' ? (
          <LineChart data={data}>
            <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
            <XAxis dataKey={xKey} fontSize={11} />
            <YAxis fontSize={11} />
            <RechartsTooltip />
            <Line type="monotone" dataKey={yKey} stroke={CHART_COLORS[0]} strokeWidth={2} />
          </LineChart>
        ) : type === 'area' ? (
          <AreaChart data={data}>
            <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
            <XAxis dataKey={xKey} fontSize={11} />
            <YAxis fontSize={11} />
            <RechartsTooltip />
            <Area type="monotone" dataKey={yKey} stroke={CHART_COLORS[0]} fill={CHART_COLORS[0]} fillOpacity={0.25} />
          </AreaChart>
        ) : (
          <BarChart data={data}>
            <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
            <XAxis dataKey={xKey} fontSize={11} />
            <YAxis fontSize={11} />
            <RechartsTooltip />
            <Bar dataKey={yKey} radius={[4, 4, 0, 0]}>
              {data.map((_, i) => <Cell key={i} fill={CHART_COLORS[i % CHART_COLORS.length]} />)}
            </Bar>
          </BarChart>
        )}
      </ResponsiveContainer>
    </div>
  );
};
